module.exports = __webpack_public_path__ + "img/HSA Retirement Infographic.e5db21ef.jpeg";